export const draftDialogEditedSelector = (state) =>
  state?.dialogEditedReducer?.dialogEdited;
export const draftDialogEditedSpeakersSelector = (state) =>
  state?.dialogEditedReducer?.dialogEditedSpeakers;
export const draftDialogEditedCommentsSelector = (state) =>
  state?.dialogEditedReducer?.dialogEditedComments;
